import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './App.css';

import Header from './components/Header';
import ScrollTopButton from './components/ScrollTopButton';
import ScrollToTop from './components/ScrollToTop';
import Footer from './components/Footer';

// Import page components
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import BlogPage from './pages/BlogPage';
import CareerPage from './pages/CareerPage';
import JobDetailPage from './pages/JobDetailPage';
import JobApplicationPage from './pages/JobApplicationPage';
import ContactPage from './pages/ContactPage';
import TeamsPage from './pages/TeamsPage';

function AppContent() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const isAboutPage = location.pathname === '/about';

  useEffect(() => {
    if (isAboutPage) {
      document.body.classList.add('page-about');
    } else {
      document.body.classList.remove('page-about');
    }
  }, [isAboutPage]);

  return (
    <>
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/teams" element={<TeamsPage />} />
          <Route path="/knowledge-hub" element={<BlogPage />} />
          <Route path="/careers" element={<CareerPage />} />
          <Route path="/careers/:jobSlug" element={<JobDetailPage />} />
          <Route path="/careers/:jobSlug/apply" element={<JobApplicationPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
        <ScrollTopButton />
      </main>
      {!isHomePage && <Footer />}
    </>
  );
}

function App() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  window.addEventListener("load", () => {
    document.body.classList.add("font-loaded");
  });

  return (
    <HelmetProvider>
      <Router>
        <AppContent />
      </Router>
    </HelmetProvider>
  );
}

export default App;
